import { useContext } from 'react';

import type { HelpContextType } from '../context/HelpContext';
import { HelpContext } from '../context/HelpContext';

export const useHelpContext = <U extends object = HelpContextType>(): U => {
  return useContext(HelpContext) as U;
};
